import { render, staticRenderFns } from "./FamilyHomeTab.vue?vue&type=template&id=0b29accb&scoped=true&"
import script from "./FamilyHomeTab.vue?vue&type=script&lang=js&"
export * from "./FamilyHomeTab.vue?vue&type=script&lang=js&"
import style0 from "./FamilyHomeTab.vue?vue&type=style&index=0&id=0b29accb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29accb",
  null
  
)

export default component.exports